export const GET_HOME_PAGE_REQUEST = 'GET_HOME_PAGE_REQUEST';
export const GET_HOME_PAGE_SUCCESS = 'GET_HOME_PAGE_SUCCESS';
export const GET_HOME_PAGE_FAIL = 'GET_HOME_PAGE_FAIL';
export const SET_HOME_PAGE_CACHED = 'SET_HOME_PAGE_CACHED';
export const SET_HOME_PAGE = 'SET_HOME_PAGE';
